import React from "react";
import { Progress } from "antd";
import ConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";
import PropTypes from "prop-types";

const TrebbleProgress = ({useEditorTheme, ...restProps}) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({useEditorTheme});

  return (
    <ConfigProvider theme={themeConfig}>
      <Progress {...restProps} />
    </ConfigProvider>
  );
};

TrebbleProgress.propTypes = {
  useEditorTheme: PropTypes.bool
}

export default TrebbleProgress; 